export function getPrefferedLanguage(fallbackLanguage = "en") {
    return fallbackLanguage;
}
